import { AclHandler } from "@/services/acl-handler.js";

export class MenuHandler {

    constructor(menu, user, isCloudMode) {
        this.fullMenu = menu;
        this.forUser = user;
        this.isCloudMode = isCloudMode;
    }

    //
    // возвращает меню, доступное пользователю
    //
    getMenuAvailableForUser() {
        if(this.forUser == undefined || this.fullMenu == null){
            return [];
        }

        // обработчик acl
        const aclHandler = new AclHandler(this.forUser, this.isCloudMode);

        let cloudModeFilteredGroups = this.fullMenu;

        // для облочной версии фильтруем элементы
        if (this.isCloudMode) {
            const removeMenuPath = ['queues', 'logs', 'settings'];
            if (!aclHandler.hasDefaultLocation()) {
                cloudModeFilteredGroups = cloudModeFilteredGroups.filter(i => !removeMenuPath.includes(i.name));
            }
        }

        const aclFilterdGroups = cloudModeFilteredGroups.filter(
            i => i.itemPermission == undefined || 
            i.itemPermission == null || 
            aclHandler.hasPermission(i.itemPermission)
        );

        return aclFilterdGroups.filter(i => i.path);
    }
}